import api from "../api/axios";

const stockService = {
  // Stok hareketleri listesi
  getStockMovements: (params) => api.get("report/stock-movements", { params }),

  // Manuel stok düzenlemesi
  manualAdjustment: (data) => api.post("stock/manual-adjustment", data),

  // Depolar arası transfer
  transfer: (data) => api.post("stock/transfer", data),
};

export default stockService;
